import { ERROR_MESSAGES } from "./errorHandler/error.messages";
import { ERROR_TYPES } from "./errorHandler/error.types";
import { NOT_NATIVE_APP_MSG } from "./native/nativeHelpers";
import { CANNOT_REQUEST_NOTIFICATION_PERMISSION_MSG, NOTIFICATION_PERMISSION_DENIED } from "./native/notificationController";

let filters = {
        // These exception messages are just noise--don't clog up Error Reporting with them
        ignoreMessages: [
            "Cancelled", // Shouldn't pop up at all. https://checkmate.fogbugz.com/f/cases/123109/
            "Unexpected end of input",
            "Login failed for user 'geotabuser'", // Unit test database deletion
            "Stopping JS execution", // Unit test thrown error
            "Bad request.", // HTTP 400. Bad Request. The server said the web client request was bad (it likely is getting garbled on the way to the server).
            "Request timeout.", // HTTP 408. Request Timeout. Not much we can do with bad cell connections.
            "Couldn't connect to the server.", // Don't care about bad or blocked requests
            ERROR_MESSAGES.OVERLIMIT, // Client is using the same call too many times at once, rate limit it
            ERROR_MESSAGES.SERVER_UNAVAILABLE, // Server is unavailable, rate limit all calls
            NOTIFICATION_PERMISSION_DENIED, // User does not have clearance or declined notification permission
            NOT_NATIVE_APP_MSG, // Not an android/iOS native application
            CANNOT_REQUEST_NOTIFICATION_PERMISSION_MSG, // Not able to request notification permission,
            "Connection refused",
            "Service temporarily unavailable.",
            "Server not found.",
            "Couldn't connect to the server. Please check your network connection, server name and try again.",
            "One of sleep mode detector listeners has thrown an error. It won't break anything, but WHY??",
            "User does not have access to this device",
            "Closing to launch another browser", // Benign SAML double-click/relaunch artifact
            "SAML login window dismissed" // User closed the SAML login window
        ],

        // Add exception types to this list that needs to be ignored
        ignoreTypes: [
            ERROR_TYPES.OVERLIMIT, // Overlimit exceptions are thrown in scenarios like API Calls Quota Exceeded, Results limit not provided
            "InvalidUserException",
            "InvalidMyAdminUserException",
            "ExpiredPasswordException",
            "ServiceUnavailableException",
            "OperationCanceledException",
            "ConnectionAbortedException",
            "TimeoutException",
            "NpgsqlException",
            "IOException",
            "TaskCanceledException",
            "ConnectionException",
            "HttpRequestException",
            "InvalidCredentialsError",
            "GenericException",
            ERROR_TYPES.DB_UNAVAILABLE
        ]
    };

    let isInList = function (errorObject, listName) {
        let list = filters[listName] || [];

        return list.some(function(listItem) {
            if (typeof listItem === "object" && errorObject && typeof errorObject === "object") {
                let key = Object.keys(listItem)[0];
                if (listItem[key] === errorObject[key]) {
                    return true;
                }
            } else if (typeof listItem === "string") {
                if (errorObject.message && errorObject.message.toLowerCase().indexOf(listItem.toLowerCase()) !== -1) {
                    return true;
                } else if (errorObject.data && errorObject.data.type.toLowerCase().indexOf(listItem.toLowerCase()) !== -1) {
                    return true;
                }
            }
            return false;
        });
    };

    export default {
        isIgnored: function (errorObject) {
            return isInList(errorObject, "ignoreMessages") || isInList(errorObject, "ignoreTypes");
        }
    };
